import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Link as MUILink } from '@mui/material';
import { scBlue100 } from 'constants/systemColors';
import { FileViewerContext } from 'contexts/FileViewerContext';
import { openFile } from 'services/fileService';

import { tasksStatusesMap } from 'components/root/Container/Layout/Tasks/Task/taskConstants';

export const LinkItem = ({ item, type }) => {
  const fileViewer = useContext(FileViewerContext);

  return type === 'file' ? (
    <MUILink
      sx={{
        color: scBlue100,
        textDecoration: 'none',
        cursor: 'pointer',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
      }}
      onClick={() => openFile(fileViewer, item)}
    >
      {item.fileTitle}
    </MUILink>
  ) : (
    <Link className="overflow-ellipsis" target="_blank" rel="noopener noreferrer" to={item.link}>{`${
      item.sequenceNumber
    }: ${item.topicName} - ${tasksStatusesMap[item.status]?.name}`}</Link>
  );
};
